export const WALKTHROUGH_ACTIVE_BODY_ATTRIBUTE = "data-redo-walkthrough-active";

export function applyWalkthroughModalSuppression(active: boolean): () => void {
  if (!active || typeof document === "undefined") {
    return () => {};
  }

  const body = document.body;
  const previousValue = body.getAttribute(WALKTHROUGH_ACTIVE_BODY_ATTRIBUTE);
  body.setAttribute(WALKTHROUGH_ACTIVE_BODY_ATTRIBUTE, "true");

  return () => {
    if (previousValue === null) {
      body.removeAttribute(WALKTHROUGH_ACTIVE_BODY_ATTRIBUTE);
      return;
    }
    body.setAttribute(WALKTHROUGH_ACTIVE_BODY_ATTRIBUTE, previousValue);
  };
}
